import React from 'react'
import styled from 'styled-components'
import media from '@styles/media'

const mobileProducts = [
  {
    name: 'SwasthaID',
    label: 'Healthcare',
    color: '#0a1628',
    accent: '#3a8fd4',
    excerpt: "Nepal's first inter-hospital health data network. Secure, instant sharing of medical records with patients controlling their own health data.",
    bg: '/images/apps/swasthaid-logo-d.png',
    logo: '/images/apps/swasthaid-logo.png',
  },
  {
    name: 'Revvlow',
    label: 'Commerce',
    color: '#1a0d08',
    accent: '#e05c2a',
    excerpt: 'Monetize unsold inventory in real time with dynamic pricing for cinemas, events & hospitality — zero disruption to your primary pricing strategy.',
    bg: '/images/apps/revvlow.jpg',
    logo: '/images/apps/revvlow-logo.svg',
  },
  {
    name: 'OsadAI',
    label: 'Wellness',
    color: '#061a0a',
    accent: '#2d7a3a',
    excerpt: 'AI-driven natural medicine & wellness platform combining Ayurveda with modern AI formulation — scientifically-backed nutraceutical solutions.',
    bg: '/images/apps/osadai.png',
    logo: null,
  },
]

function LabsPreviewMobile() {
  return (
    <>
      {mobileProducts.map(p => (
        <PreviewCard key={p.name} color={p.color} accent={p.accent}>
          <CardTop>
            <CardLabel accent={p.accent}>{p.label}</CardLabel>
            <CardLogoRow>
              {p.logo ? (
                <img
                  src={p.logo}
                  alt={p.name}
                  style={{ height: '36px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
                />
              ) : (
                <OsadInline>
                  <OsadLeaf />
                  <OsadName>OsadAI</OsadName>
                </OsadInline>
              )}
            </CardLogoRow>
            <CardName accent={p.accent}>{p.name}</CardName>
            <CardExcerpt>{p.excerpt}</CardExcerpt>
          </CardTop>
          <CardBg src={p.bg} />
          <Border accent={p.accent} />
          <CardFooter>Contact us to learn more →</CardFooter>
        </PreviewCard>
      ))}
    </>
  )
}

export default LabsPreviewMobile

const PreviewCard = styled.div<{ color: string; accent: string }>`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: ${p => p.color};
  border: 1px solid ${p => p.accent}33;
  margin-bottom: 24px;

  ${media.desktop_up`
    display: none;
  `}
`

const CardTop = styled.div`
  position: relative;
  z-index: 1;
  padding: 32px 28px 20px;
`

const CardLabel = styled.span<{ accent: string }>`
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${p => p.accent};
  background: ${p => p.accent}22;
  border-radius: 4px;
  padding: 3px 10px;
  margin-bottom: 16px;
`

const CardLogoRow = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

const CardName = styled.h3<{ accent: string }>`
  font-size: 2.6rem;
  font-weight: 700;
  color: ${p => p.accent};
  letter-spacing: -0.5px;
  margin-bottom: 10px;
`

const CardExcerpt = styled.p`
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.6;
`

const CardBg = styled.img`
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
  opacity: 0.15;
`

const Border = styled.div<{ accent: string }>`
  height: 1px;
  background: ${p => p.accent}33;
`

const CardFooter = styled.div`
  padding: 18px 28px;
  font-size: 1.4rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
`

const OsadInline = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const OsadLeaf = styled.div`
  width: 24px;
  height: 24px;
  background: #2d7a3a;
  border-radius: 50% 0 50% 0;
  transform: rotate(45deg);
  flex-shrink: 0;
`

const OsadName = styled.span`
  font-size: 1.8rem;
  font-weight: 700;
  color: #2d7a3a;
  letter-spacing: -0.5px;
`
